import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "upload-inner" }
const _hoisted_4 = { class: "correct-tip" }
const _hoisted_5 = { style: {"margin":"20px 0"} }
const _hoisted_6 = { class: "page-inner page-right" }
const _hoisted_7 = { class: "page-box-title2 title1" }
const _hoisted_8 = {
  key: 0,
  class: "page-inner-box"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "page-inner-box empty"
}

import clipBoard from "vue-clipboard3"
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compPolishingStreamingV2, saveSreamResult, getRewrite, getCorrecting, checkAiCall } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import { useRoute } from 'vue-router';
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'polishPage',
  setup(__props) {

const store = useStore();
let { toClipboard } = clipBoard()
const route = useRoute()
const polishText = ref('')
const artiRewriteId = ref('')
const artiCorrectingId = ref('')

const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const aiStart = ref(false)
const popupShow = ref(false)
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function polishClick() {
    if (!polishText.value && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}

function getAi() {
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        text: polishText.value || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
        artiRewriteId: artiRewriteId.value || '',
        artiCorrectingId: artiCorrectingId.value || ''
    }
    aiStart.value = true
    popupShow.value = true
    fetchRequest({
        url: compPolishingStreamingV2,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
    // compPolishingStreaming(params).then(res => {
    //     fetchRequest(res.data)
    // }).catch(() => {
    //     aiStart.value = false
    //     popupShow.value = false
    // })
}


async function copyEvent() {
    try {
        let text = ''
        if (Object.keys(resultInfo.value).length) {
            if (!resultInfo.value.Ⅱ || !resultInfo.value.Ⅱ.length) {
                return ElMessage.success('当前没有符合要求的内容')
            }

            if (resultInfo.value.Ⅰ && resultInfo.value.Ⅰ.length) {
                text = resultInfo.value.Ⅰ[0]
            }
            text = (text + resultInfo.value.Ⅱ[0]).replace(/<br\/>/g, "\n");
        } else {
            text = aiMessage.value.replace(/[ⅠⅡⅢⅣⅤ]/g, '\n')
        }
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    aiMessage.value = ''
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const { signal } = controller;
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }

    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                if (line.indexOf('Done') > -1) {
                    isMessage = false;
                    aiStart.value = false
                }
                if (line.indexOf('Error') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (line.indexOf('"500"') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    let errorMsg = JSON.parse(line).msg;
                    return ElMessage.warning(errorMsg || 'AI调用失败，请稍后再试！');
                }
                if (isMessage && line.indexOf('content') > -1) {
                    let jsonString = '';
                    if (line.startsWith('data:')) {
                        jsonString = line.substring(5).trim();
                    } else {
                        jsonString = line
                    }

                    if (jsonString) {
                        try {
                            const jsonData = JSON.parse(jsonString)
                            const content = (jsonData ?.content || '');
                            if (content) {
                                str += content
                                const matches = content.match(regex) || [];
                                let resultArr = matches.filter(match => match !== '');
                                resultArr.forEach(info => {
                                    if (romanNumerals.includes(info)) {
                                        if (info in resultNum) {
                                            resultNum[info] = resultNum[info] + 1;
                                            resultInfo.value[info].push('');
                                        } else {
                                            resultNum[info] = 1;
                                            resultInfo.value[info] = [''];
                                        }
                                        currentKey = info;
                                    } else if (currentKey in resultInfo.value) {
                                        if (resultNum[currentKey] == 1) {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                        } else {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                        }

                                    }
                                })
                                console.log(resultInfo.value)
                                aiMessage.value = str
                            }
                        } catch (error) {
                            console.log(error)
                            aiStart.value = false
                            return ElMessage.warning('AI调用失败，请稍后再试！');
                        }
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}

function getDetail() {
    const api = artiRewriteId.value ? getRewrite : getCorrecting;
    api(artiRewriteId.value || artiCorrectingId.value).then(res => {
        const ids = res.data.artiCorrectingFileIds || res.data.artiRewriteFileIds || '';
        const fileids = ids ? ids.split(',') : [];
        fileList.value = (res.data.artiCorrectingFileUrlList || res.data.artiRewriteFileUrlList || [])
            .map((item, index) => {
                return {
                    fileUrl: item,
                    url: item,
                    fileId: fileids[index]
                }
            });
        fileArr = fileList.value;
        previewFileArr.value = (res.data.artiCorrectingFileUrlList || res.data.artiRewriteFileUrlList || [])
        console.log(previewFileArr.value)
        polishText.value = res.data.artiCorrectingTxt || res.data.artiRewriteTxt || '';
    })
}

onBeforeUnmount(() => {
    controller && controller.abort()
})

onMounted(() => {
    artiRewriteId.value = route.query.artiRewriteId || '';
    artiCorrectingId.value = route.query.artiCorrectingId || '';
    if (artiRewriteId.value || artiCorrectingId.value) {
        getDetail()
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Camera = _resolveComponent("Camera")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-box-title title1" }, "作文润色", -1)),
      _createElementVNode("div", null, [
        (((artiRewriteId.value || artiCorrectingId.value) && polishText.value.length) || (!artiRewriteId.value && !artiCorrectingId.value))
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              gutter: 10,
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      maxlength: "5000",
                      modelValue: polishText.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((polishText).value = $event)),
                      disabled: (artiRewriteId.value || artiCorrectingId.value)?true:false,
                      type: "textarea",
                      rows: 6,
                      placeholder: "请输入作文文本，文本拍照二选一即可"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_row, {
          gutter: 10,
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-box",
                  disabled: (artiRewriteId.value || artiCorrectingId.value)?true:false,
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
                  action: "#",
                  max: 5,
                  "list-type": "picture-card",
                  "http-request": httpRequest,
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_icon, { size: "24" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Camera)
                          ]),
                          _: 1
                        })
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("div", null, "作文上传", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", _hoisted_4, _cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "activeColor" }, "*提示：", -1),
          _createElementVNode("span", null, "一次拍一页，可多次拍摄，最多可拍摄5页", -1)
        ]), 512), [
          [_vShow, !artiRewriteId.value && !artiCorrectingId.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          disabled: aiStart.value,
          style: {"width":"100%"},
          color: "#ef8b25",
          class: "footer-btn1",
          onClick: polishClick
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("AI作文润色")
          ])),
          _: 1,
          __: [5]
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "AI润色结果", -1)),
        ((Object.keys(_unref(resultInfo)).length || _unref(aiMessage)) && !aiStart.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              style: {"float":"right"},
              color: "#ef8b25",
              class: "footer-btn1",
              onClick: copyEvent
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("复制全文")
              ])),
              _: 1,
              __: [7]
            }))
          : _createCommentVNode("", true)
      ]),
      (Object.keys(_unref(resultInfo)).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "correctTitle" }, "润色后的作文", -1)),
            (_unref(resultInfo).Ⅰ && _unref(resultInfo).Ⅰ.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(resultInfo).Ⅰ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "correctTitle2",
                    style: {"text-align":"center"},
                    key: 'PⅠ'+index
                  }, [
                    _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_9)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅱ && _unref(resultInfo).Ⅱ.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(resultInfo).Ⅱ, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "correctTitle5",
                    key: 'PⅡ'+index
                  }, [
                    _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_10)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅲ && _unref(resultInfo).Ⅲ.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "correctTitle" }, " 修改思路和方法 ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅲ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"text-indent":"unset"},
                      class: "correctTitle5",
                      key: 'PⅢ'+index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_11)
                    ]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && _unref(aiMessage) && _unref(aiMessage)!='{}')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            innerHTML: _unref(aiMessage),
            class: "page-inner-box"
          }, null, 8, _hoisted_12))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && !_unref(aiMessage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[11] || (_cache[11] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "结果将在此处展示！", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    (showPreview.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewFileArr.value,
          "show-progress": "",
          "initial-index": previewIndex.value,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showPreview.value = false))
        }, null, 8, ["url-list", "initial-index"]))
      : _createCommentVNode("", true),
    (popupShow.value)
      ? (_openBlock(), _createBlock(AIpopup, {
          key: 1,
          cancelShow: false,
          popupShow: popupShow.value,
          onCancel: aiCancel
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true)
  ]))
}
}

})